module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-white.62d8a0dd.svg";